import request from './axiosFun';
// 根据用户id，项目id 查询用户开通项目
var url = '';
if (process.env.NODE_ENV === 'development') {
  url = '/est';
} else {
  url = '';
}
// 新分页查询物料信息
export function pageMatterInfo(query) {
  return request({
    url: url + '/livestock/materInfo/pageMaterInfo',
    method: 'post',
    data: query
  });
}
// 新编辑物料信息
export function EditItem(query) {
  return request({
    url: url + '/livestock/materInfo/updateMaterInfo',
    method: 'post',
    data: query
  });
}
// 新物料分类统计
export function materialstatistics(query) {
  return request({
    url: url + '/livestock/materInfo/typeCount',

    method: 'post',
    data: query
  });
}
// 新防疫任务
export function preventiontask(query) {
  return request({
    url: url + '/livestock/materInfo/getTaskInfoList',

    method: 'post',
    data: query
  });
}
// 新出库列表信息
export function Issuelist(query) {
  return request({
    url: url + '/livestock/outStockInfo/queryOutStockList',

    method: 'post',
    data: query
  });
}
// 新领取入库下发列表信息   待领取列表
export function listinformation(query) {
  return request({
    url: url + '/livestock/sendRecordLog/querySendRecordLogList',

    method: 'post',
    data: query
  });
}
// 出入库列表
export function pageMatterRecord(query) {
  return request({
    url: url + '/livestock/matterrecord/pageMatterRecord',

    method: 'post',
    data: query
  });
}

// 出入库删除
export function delMatterRecord(query) {
  return request({
    url: url + '/livestock/matterrecord/delMatterRecord/' + query,

    method: 'post'
  });
}

// 类型
export function countMatterInfoByC(query) {
  return request({
    url: url + '/livestock/mattercategory/countMatterInfoByCategory',
    method: 'post',
    data: query
  });
}
// 待领取列表
export function pageList(query) {
  return request({
    url: url + '/livestock/matterreceiveordistribute/page',
    method: 'post',
    data: query
  });
}
// 领取物料

export function materialCollection(query) {
  return request({
    url: url + '/livestock/matterreceiveordistribute/materialCollection',
    method: 'post',
    data: query
  });
}

// 下发人
export function getUserListByAreasId(query) {
  return request({
    url: url + '/pasture/userInfo/getUserListByAreasId',
    method: 'post',
    data: query
  });
}
// 新增物料
export function saveMatterRecord(query) {
  return request({
    url: url + '/livestock/materInfo/saveMaterInfo',

    method: 'post',
    data: query
  });
}
// 下发修改下发机构
export function modifytheorganization(query) {
  return request({
    url: url + '/livestock/sendRecordLog/updSendRecodeLogIssued',

    method: 'post',
    data: query
  });
}
// 新入库/下发  待领取领取   待领取退还  退回
export function warehousing(query) {
  return request({
    url: url + '/livestock/sendRecordLog/addSendRecodeLogStock',

    method: 'post',
    data: query
  });
}
// 单位字典

export function findDictList(query) {
  return request({
    url: url + '/base-server/homeCenter/sysInfo/findDictList',
    method: 'post',
    data: query
  });
}
// 物料下发

export function materialDelivery(query) {
  return request({
    url: url + '/livestock/matterreceiveordistribute/materialDelivery',
    method: 'post',
    data: query
  });
}
// 删除物料
export function delMatterInfo(query) {
  return request({
    url: url + '/livestock/materInfo/delMaterInfo/' + query,
    method: 'post'
  });
}
// 删除物料(2024-09-11)李哥新增接口
export function removeDeptMater(data) {
  return request({
    url: url + '/livestock/materInfo/removeDeptMater',
    method: 'post',
    data
  });
}

// 下发列表

export function pageForOut(data) {
  return request({
    url: url + '/livestock/matterrecord/pageMatterRecordForOut',
    method: 'post',
    data
  });
}
// 新人员列表
export function getUserList(query) {
  return request({
    url: url + '/livestock/sendRecordLog/queryDeptUserName',
    method: 'post',
    data: query
  });
}
// 出库新人员列表
export function chukugetUserList(query) {
  return request({
    url: url + '/livestock/outStockInfo/queryDeptUserName',
    method: 'post',
    data: query
  });
}
// // 人员列表
// export function getUserList (query) {

//   return request({
//     url: url +'/pasture/userInfo/getUserListByAreasIdWithPageInfo',
//     method: 'post',
//     data: query

//   })
// }
// 新下发机构列表
export function Issuingagency(query) {
  return request({
    url: url + '/pasture/sys/getNextDeptListByPId',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/material.js